import { memo, useCallback, useState } from "react";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Highlight from "./Highlight/Highlight";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import TitledViewerTop from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/ViewerTop/TitledViewerTop/TitledViewerTop";
import TaskState, {
  TASK_STATES,
} from "@coworker/apprestructured/src/task-management/types/TaskState";
import {
  FixaOption,
  FixaSelect,
} from "@coworker/apprestructured/src/shared/wrappers/FixaSelect/FixaSelect";

function TitledViewerTopDemo() {
  const [title, setTitle] = useState("Task title");
  const [subtitle, setSubtitle] = useState("Created 2025-09-22 11:17");
  const [state, setState] = useState<TaskState>("pending");
  const [badge, setBadge] = useState("3 days overdue");

  const handleCloseButtonClick = useCallback(() => {
    alert("onCloseButtonClick");
  }, []);

  const handleMenuButtonClick = useCallback(() => {
    alert("onMenuButtonClick");
  }, []);

  return (
    <Demo>
      <Name>TitledViewerTop</Name>
      <Highlight>
        <TitledViewerTop
          title={title}
          subtitle={subtitle}
          state={state}
          onCloseButtonClick={handleCloseButtonClick}
          onMenuButtonClick={handleMenuButtonClick}
          badge={badge.length > 0 ? badge : null}
        />
      </Highlight>
      <Actions>
        <FixaInputField
          id="customtasksheettopdemo-title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          type="text"
          label="title"
        />
        <FixaInputField
          id="customtasksheettopdemo-subtitle"
          value={subtitle}
          onChange={(e) => setSubtitle(e.target.value)}
          type="text"
          label="subtitle"
        />
        <FixaInputField
          id="customtasksheettopdemo-badge"
          value={badge}
          onChange={(e) => setBadge(e.target.value)}
          type="text"
          label="badge"
        />
        <FixaSelect
          id="customtasksheettopdemo-iconName"
          value={state}
          onChange={(e) => setState(e.target.value as TaskState)}
          label="state"
          required
        >
          {TASK_STATES.map((state) => {
            return <FixaOption key={state} name={state} value={state} />;
          })}
        </FixaSelect>
      </Actions>
    </Demo>
  );
}

export default memo(TitledViewerTopDemo);
